// Что сказать человеку, когда `PATCH /users/me/birth` не принял данные рождения.
//
// Раньше эта мутация молчала на любую ошибку: кнопка «не работала», и почему — узнать было
// неоткуда. Кодов у ручки три (docs/backend.md §5), и каждый из них человек обязан прочитать
// словами, а не догадаться.

import { copy } from '~/modules/lunya'
import { isHttpError } from '~/shared/api'

/** Ненайденный город сервер отдаёт общим `VALIDATION_ERROR`, а поле называет в `details`. */
function isUnknownCityError(details: unknown): boolean {
  return typeof details === 'object' && details !== null && 'birth_city_id' in details
}

export function resolveBirthErrorText(error: unknown): string {
  if (!isHttpError(error)) return copy.profile.save_error

  if (error.code === 'AGE_RESTRICTED') return copy.profile.birth_error_age
  if (error.code === 'BIRTH_DATE_IN_FUTURE') return copy.profile.birth_error_future
  if (error.code === 'VALIDATION_ERROR' && isUnknownCityError(error.details)) {
    return copy.profile.birth_error_city
  }

  // Остальное — сеть, 5xx, незнакомый код: обещать конкретную причину нечестно, но молчать
  // нельзя тем более.
  return copy.profile.save_error
}
